/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Error_Invalid_Booking_YearInputs */

const en_ledger_error_invalid_booking_year = /** @type {(inputs: Ledger_Error_Invalid_Booking_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The query returned an invalid booking year`)
};

const nl_ledger_error_invalid_booking_year = /** @type {(inputs: Ledger_Error_Invalid_Booking_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De query gaf een ongeldig boekjaar terug`)
};

/**
* | output |
* | --- |
* | "The query returned an invalid booking year" |
*
* @param {Ledger_Error_Invalid_Booking_YearInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_error_invalid_booking_year = /** @type {((inputs?: Ledger_Error_Invalid_Booking_YearInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Error_Invalid_Booking_YearInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_error_invalid_booking_year(inputs)
	return en_ledger_error_invalid_booking_year(inputs)
});